var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTablerHeartHandshake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.0001 41.9066L40.0001 66.6666L15.0001 41.9066C13.3511 40.302 12.0522 38.3734 11.1853 36.2421C10.3183 34.1108 9.90198 31.8231 9.96257 29.5231C10.0232 27.223 10.5593 24.9604 11.5373 22.8778C12.5153 20.7951 13.9139 18.9375 15.6451 17.4219C17.3762 15.9063 19.4025 14.7656 21.5961 14.0716C23.7898 13.3776 26.1035 13.1453 28.3913 13.3893C30.6792 13.6334 32.8918 14.3485 34.8897 15.4897C36.8876 16.6308 38.6276 18.1733 40.0001 20.02C41.3786 18.1867 43.1206 16.6577 45.1171 15.5287C47.1137 14.3996 49.3218 13.6948 51.6032 13.4584C53.8847 13.2219 56.1904 13.459 58.376 14.1546C60.5617 14.8503 62.5802 15.9896 64.3053 17.5012C66.0304 19.0128 67.4249 20.8643 68.4015 22.9396C69.3782 25.015 69.9159 27.2696 69.9811 29.5623C70.0464 31.8551 69.6376 34.1366 68.7806 36.2641C67.9235 38.3917 66.6365 40.3194 65.0001 41.9266",
    stroke: "#A95959",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20L29.0233 30.9767C28.3984 31.6018 28.0474 32.4495 28.0474 33.3333C28.0474 34.2172 28.3984 35.0649 29.0233 35.69L30.8333 37.5C33.1333 39.8 36.8667 39.8 39.1667 37.5L42.5 34.1667C44.4891 32.1776 47.1869 31.0601 50 31.0601C52.813 31.0601 55.5109 32.1776 57.5 34.1667L65 41.6667M41.6667 51.6667L48.3333 58.3333M50 43.3333L56.6667 50",
    stroke: "#A95959",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerHeartHandshake);
export default __webpack_public_path__ + "static/media/tabler_heart-handshake.a95de3e3bf224cc69619618324bdc5b6.svg";
export { ForwardRef as ReactComponent };